import { useNavigate } from 'react-router-dom'

import LazyImage from '@/components/lazy-image'
import { Button } from '@/components/ui/button'

import { PremioLojaItem } from '../types'

import goldCoin from '@/assets/gold-coin.svg'
import goldPrisma from '@/assets/gold-prisma.svg'
import gifImg from '@/assets/loading2.gif'
import prodSemImg from '@/assets/produto-sem-imagem.webp'
import { rotasApp } from '@/configurações/rotasApp'

interface PrêmioRenderProps {
  premio: PremioLojaItem
}

export const PrêmioRender = ({ premio }: PrêmioRenderProps) => {
  const navigate = useNavigate()

  return (
    <div className='flex min-h-60 w-full rounded-xl border border-esforce-pink-200/50'>
      <div className='flex-1'>
        <LazyImage
          src={premio?.arquivoLink ? premio.arquivoLink : prodSemImg}
          alt={premio.nome}
          className={`h-full w-full rounded-s-xl object-cover ${premio.estoque <= 0 && 'grayscale'} `}
          placeholder={gifImg}
        />
      </div>
      <div className='flex flex-1 flex-col justify-between rounded-e-xl bg-esforce-black-300 p-6'>
        <hgroup>
          <h3 className='mb-3 line-clamp-1 text-lg font-semibold capitalize text-white'>
            {premio.nome}
          </h3>
          <div className='flex flex-col gap-1'>
            <div className='flex items-center gap-2 text-sm'>
              <div
                className={`flex size-6 items-center justify-center gap-1 rounded-[6px] border border-esforce-green-200 bg-esforce-green-700 ${premio.estoque <= 0 && 'grayscale'} `}
              >
                <img
                  src={goldCoin}
                  alt='gold coin icon'
                  className={`size-2.5 ${premio.estoque <= 0 && 'grayscale'} `}
                />
              </div>
              <span className='text-xs font-normal text-esforce-white-100'>
                {premio.tipoResgate === 'RANKING'
                  ? `${premio.posicaoRanking}º lugar | ${premio.tipoRanking.toLocaleUpperCase()}`
                  : `${premio.valorEmPontos} pontos`}
              </span>
            </div>

            <div className='flex items-center gap-2 text-sm text-zinc-300'>
              <div
                className={`flex size-6 items-center justify-center gap-1 rounded-[6px] border border-esforce-green-200 bg-esforce-green-700 ${premio.estoque <= 0 && 'grayscale'} `}
              >
                <img
                  src={goldPrisma}
                  alt='gold coin icon'
                  className={`w-2 ${premio.estoque <= 0 && 'grayscale'} `}
                />
              </div>
              <span className='text-xs font-normal text-esforce-white-100'>
                {premio.estoque} em estoque
              </span>
            </div>
          </div>
        </hgroup>

        <Button
          disabled={premio.estoque <= 0}
          size='xl'
          type='button'
          onClick={() => navigate(rotasApp.visualizarPrêmio(premio.id))}
          className={`mt-7 w-full cursor-pointer bg-esforce-green-200 text-sm font-bold text-esforce-black-200 hover:bg-esforce-green-100 ${premio.estoque <= 0 && 'grayscale'} `}
        >
          Visualizar prêmio
        </Button>
      </div>
    </div>
  )
}
